import { useCallback } from 'react';

/**
 * Hook for refreshing messages and hiring data after hiring operations
 * @param {Object} options - Configuration options
 * @param {number} options.conversationId - Conversation ID
 * @param {Function} options.setMessages - Function to update messages state
 * @param {Function} options.setHiringData - Function to update hiring data state
 * @returns {Function} Refresh function
 */
const useRefreshHiringData = ({ conversationId, setMessages, setHiringData }) => {
  const refresh = useCallback(async () => {
    if (!conversationId) return;

    // Message is already sent by backend, just refresh messages to show it
    // The socket should handle it, but we'll fetch to be sure
    const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/conversations/${conversationId}/messages`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });
    
    if (response.ok) {
      const data = await response.json();
      if (data.success && data.data) {
        setMessages(data.data);
      }
    }

    // Refresh hiring data
    const hiringResponse = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/hirings/conversation/${conversationId}`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    
    if (hiringResponse.ok) {
      const hiringData = await hiringResponse.json();
      if (hiringData.success && hiringData.data) {
        setHiringData(hiringData.data);
      }
    }
  }, [conversationId, setMessages, setHiringData]);

  return refresh;
};

export default useRefreshHiringData;

